import { Grid } from "@mui/material";
import { useContext, useState } from "react";
import { AuthContext } from "core/contexts/auth/auth";
import { createDocumentSubmittal } from "modules/agentMySecurity/services/embeddingsService";
import { FormContainer, FormTitle, StyledTextField, StyledMultilineText, ActionButton } from "./home.styled";

function CreateDocument() {
    const { checkAuthToken } = useContext(AuthContext);
    const [formData, setFormData] = useState({
        collectionName: "",
        text: "",
        embedModel: "",
    });

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    async function submitDocument(e) {
        e.preventDefault();
        const token = await checkAuthToken();
        createDocumentSubmittal(token, formData);
    }

    return (
        <FormContainer>
            <form id="createDocumentForm" onSubmit={submitDocument}>
                <FormTitle>Create a Document</FormTitle>
                <Grid container spacing={3} direction="column">
                    <Grid item>
                        <StyledTextField
                            name="collectionName"
                            label="Collection Name"
                            fullWidth
                            required
                            variant="outlined"
                            value={formData.collectionName}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item>
                        <StyledMultilineText
                            name="text"
                            label="Document Text"
                            fullWidth
                            required
                            multiline
                            rows={4}
                            variant="outlined"
                            value={formData.text}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item>
                        <StyledTextField
                            name="embedModel"
                            label="Embed Model"
                            fullWidth
                            variant="outlined"
                            value={formData.embedModel}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item>
                        <ActionButton type="submit" variant="contained" color="primary" fullWidth>
                            Create Document
                        </ActionButton>
                    </Grid>
                </Grid>
            </form>
        </FormContainer>
    );
}

export default CreateDocument;